import request from '@/http/request';

export function getRemovalList(data) {
  return request({
    url: '/api/v1/ops/get_ticket_list',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
export function getMachineList(data) {
  return request({
    url: '/api/v1/ops/get_idcp_info',
    method: 'post',
    data: data,
  });
}

export function getResourceDeliveryList(data) {
  return request({
    url: '/api/v1/ops/get_source_list',
    method: 'post',
    data: data,
  });
}

export function exportResourceList(data) {
  return request({
    url: '/api/v1/ops/export_source_list',
    method: 'post',
    data: data,
  });
}

export function getDiagnoseList(data) {
  return request({
    url: '/api/v1/ops/get_diagnose_list',
    method: 'post',
    data: data,
  });
}
export function exportDiagnoseList(data) {
  return request({
    url: '/api/v1/ops/export_diagnose_list',
    method: 'post',
    data: data,
  });
}

export function getRepairList(data) {
  return request({
    url: '/api/v1/ops/get_repair_list',
    method: 'post',
    data: data,
  });
}

export function exportRepairList(data) {
  return request({
    url: '/api/v1/ops/export_repair_list',
    method: 'post',
    data: data,
  });
}

export function getComponentList(data) {
  return request({
    url: '/api/v1/ops/get_component_list',
    method: 'post',
    data: data,
  });
}

export function getServiceOtherList(data) {
  return request({
    url: '/api/v1/ops/get_service_other_list',
    method: 'post',
    data: data,
  });
}

export function exportComponentList(data) {
  return request({
    url: '/api/v1/ops/export_component_list',
    method: 'post',
    data: data,
  });
}

export function exportServiceOtherList(data) {
  return request({
    url: '/api/v1/ops/export_service_other_list',
    method: 'post',
    data: data,
  });
}

//资产总查询接口
export function getAssetMove(data) {
  return request({
    url: '/api/v1/ops/asset_info',
    method: 'post',
    data: data,
  });
}

export function getAssentEnter(data) {
  return request({
    url: '/api/v1/ops/get_assent_enter',
    method: 'post',
    data: data,
  });
}



export function exportAssetMove(data) {
  return request({
    url: '/api/v1/ops/export_asset_move',
    method: 'post',
    data: data,
  });
}



export function exportAssentEnter(data) {
  return request({
    url: '/api/v1/ops/export_assent_enter',
    method: 'post',
    data: data,
  });
}